import React from "react";

const Minumum = () => {
  return (
    <div>
      <div className="Rey---Head---card---ModalRecent1stbox mt-4">
        <span style={{ opacity: 0.6, color: "white" }}>Minimum Recieved</span>
        <span style={{ color: "white" }}> 24.2 Usdt</span>
      </div>
      <div className="Rey---Head---card---ModalRecent1stbox">
        <span style={{ opacity: 0.6, color: "white" }}>Price Impact</span>
        <span style={{ color: "white" }}> 0.001%</span>
      </div>
      <div className="Rey---Head---card---ModalRecent1stbox">
        <span style={{ opacity: 0.6, color: "white" }}>
          Liquidity Provider Fee
        </span>
        <span style={{ color: "white" }}> 0.01%</span>
      </div>
    </div>
  );
};
export default Minumum;
